import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AllHomeText, AllProgramList } from "../../features/admin/common/Slice";

function Header() {
  const dispatch = useDispatch();

  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPrograms, setShowPrograms] = useState(false);
  const isHomePage = location.pathname === "/";

  const all_home_text = useSelector((state) => state?.common?.all_home_text);
  const program_list = useSelector((state) => state?.common?.all_program_list);

  useEffect(() => {
    dispatch(AllHomeText());
    dispatch(AllProgramList());
  }, [dispatch]);

  return (
    <>
      <section className="main_head">
        <div>
          {isHomePage && (
            <div
              className="top_bar"
              dangerouslySetInnerHTML={{ __html: all_home_text?.name || "" }}
            />
          )}
        </div>

        <div className="container-md">
          <Navbar
            expand="lg"
            className="main_navbar p-0"
            onToggle={(value) => setExpanded(value)}
            expanded={expanded}
          >
            <Navbar.Brand>
              <div
                className="logodiv"
                onClick={() => {
                  setExpanded(false);
                  navigate("/");
                }}
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/header/Final_Logo.png"
                  }
                  alt="Logo"
                  className="logo_img"
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto nav_links">
                <Nav.Link
                  as={Link}
                  to={"/"}
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                {/* <NavDropdown title="Programs" id="programs_dropdown">
                  <NavDropdown.Item
                    as={Link}
                    to={"/interview-guides"}
                    onClick={() => setExpanded(false)}
                    className={
                      location.pathname === "/interview-guides" ? "active" : ""
                    }
                  ></NavDropdown.Item>

                  {program_list?.map((program) => (
                    <NavDropdown.Item
                      key={program.id}
                      as={Link}
                      to={`/explore-program/${program.id}`}
                      onClick={() => setExpanded(false)}
                      className={
                        location.pathname === `/program/${program.id}`
                          ? "active"
                          : ""
                      }
                    >
                      {program.name}
                    </NavDropdown.Item>
                  ))} */}

                {/* Interview guides
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to={"/"}
                    onClick={() => setExpanded(false)}
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Data Engineering ⭐
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={"/"}
                    onClick={() => setExpanded(false)}
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Data Analytics ⭐
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={"/"}
                    onClick={() => setExpanded(false)}
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Cloud & Big Data
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    as={Link}
                    to={"/"}
                    onClick={() => setExpanded(false)}
                    className={location.pathname === "/" ? "active" : ""}
                  >
                    Foundations (Python, SQL)
                  </NavDropdown.Item> */}

                {/* <NavDropdown.Item
                    as={Link}
                    to={"/explore-program"}
                    onClick={() => setExpanded(false)}
                    className={
                      location.pathname === "/explore-program" ? "active" : ""
                    }
                  >
                    Job-Ready Program
                  </NavDropdown.Item>
                </NavDropdown> */}

                <NavDropdown
                  title="Programs"
                  id="programs_dropdown"
                  className="programs_dropdown"
                  show={showPrograms}
                  onToggle={(isOpen) => setShowPrograms(isOpen)}
                >
                  <div className="programs_menu">
                    <p className="programs_heading">PROGRAMS</p>

                    <div className="programs_grid">
                      {program_list?.map((program) => (
                       <Link
  key={program.id}
  to={`/explore-program/${program.id}`}
  className={`program_item ${
    location.pathname === `/explore-program/${program.id}` ? "active" : ""
  }`}
  onClick={() => {
    setExpanded(false);
    setShowPrograms(false);
  }}
>
  <h6>{program.name}⭐</h6>
  <p>Learn {program.name} with structured modules.</p>
</Link>
                      ))}
{/* 
                      <Link
                        to="/explore-program"
                        className="program_item"
                        onClick={() => setExpanded(false)}
                      >
                        <h6>Job-Ready Program</h6>
                        <p>
                          Complete program designed to make you industry ready.
                        </p>
                      </Link> */}
                    </div>
                  </div>
                </NavDropdown>
                <NavDropdown
                  title="Resources"
                  id="resources-dropdown"
                  className="resources_dropdown"
                  show={showDropdown}
                  onToggle={(isOpen) => setShowDropdown(isOpen)}
                >
                  <div className="resources_menu">
                    <p className="resources_heading">RESOURCES</p>

                    <div className="resources_grid">
                      <Link
                        className="resource_item"
                        to="/interview-guides"
                        onClick={() => {
                          setExpanded(false);
                          setShowDropdown(false);
                        }}
                      >
                        <h6>Interview Guides</h6>
                        <p>
                          Understand crucial concepts using structured guides.
                        </p>
                      </Link>

                      <Link
                        className="resource_item"
                        to="/claim-certificate"
                        onClick={() => {
                          setExpanded(false);
                          setShowDropdown(false);
                        }}
                      >
                        <h6>Practice Test</h6>
                        <p>Practice questions across multiple domains.</p>
                      </Link>

                      <Link
                        className="resource_item"
                        to="/blogs"
                        onClick={() => {
                          setExpanded(false);
                          setShowDropdown(false);
                        }}
                      >
                        <h6>Blog</h6>
                        <p>
                          Read insights, tips, and updates from industry
                          experts.
                        </p>
                      </Link>
                    </div>
                  </div>
                </NavDropdown>

                <Nav.Link
                  as={Link}
                  to={"/contact-us"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/contact-us" ? "active" : ""
                  }
                >
                  Contact Us
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to={"/pst-it-solutions"}
                  onClick={() => setExpanded(false)}
                  className={
                    location.pathname === "/pst-it-solutions" ? "active" : ""
                  }
                >
                  PST IT Solutions
                </Nav.Link>
              </Nav>

              {/* CTA Button */}
              <button
                className="claim_btn"
                onClick={() => {
                  navigate("/claim-certificate");
                  setExpanded(false);
                }}
              >
                Claim Free Certificate
              </button>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </section>
    </>
  );
}

export default Header;
